/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Page_User_LabelInputs */

const en_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const de_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

const pt_br2_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário`)
};

const tr_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı`)
};

const zh_cn2_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户`)
};

const zh_hk2_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用戶`)
};

const ko_kr2_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자`)
};

const ru_ru2_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь`)
};

const es_419_user_profile_page_user_label = /** @type {(inputs: User_Profile_Page_User_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {User_Profile_Page_User_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const user_profile_page_user_label = /** @type {((inputs?: User_Profile_Page_User_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Page_User_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_profile_page_user_label(inputs)
	if (locale === "de") return de_user_profile_page_user_label(inputs)
	if (locale === "pt-BR") return pt_br2_user_profile_page_user_label(inputs)
	if (locale === "tr") return tr_user_profile_page_user_label(inputs)
	if (locale === "zh-CN") return zh_cn2_user_profile_page_user_label(inputs)
	if (locale === "zh-HK") return zh_hk2_user_profile_page_user_label(inputs)
	if (locale === "ko-KR") return ko_kr2_user_profile_page_user_label(inputs)
	if (locale === "ru-RU") return ru_ru2_user_profile_page_user_label(inputs)
	return es_419_user_profile_page_user_label(inputs)
});